<template>
  <div class="authentication" :style="{ height: documentClientHeight }">
    <el-row style="height: 100%">
      <el-col :span="11" class="left">
        <div class="logo"></div>
        <p class="title">进口查询</p>
        <div class="result">
          <div class="result-title">查询结果</div>
          <p style="margin: 40px 0 20px">{{info.name || '该供应商'}}于 {{info.portDate}}委托一咻通关报关进口该型号产品一批，报关单号 <span style="cursor: pointer;" @click="copyNmuber(info.customsNumber)">{{info.customsNumber}}<ab-svg style="width: 14px; height: 14px; vertical-align: text-top; margin: 3px 0 0 4px" name="copy"></ab-svg>复制</span> <span style="color: #1884ff; cursor: pointer" @click="open('http://online.customs.gov.cn/ociswebserver/pages/tglzzt/index.html')">>>去海关官网检验。</span>
          </p>
          <p>感谢您的查询！</p>
        </div>
      </el-col>
      <el-col :span="13" class="right">
        <div class="info">
          <p>
            <ab-svg name="wangzhi"></ab-svg>
            一咻通关网址：<span style="color: #1884ff; cursor: pointer" @click="open('www.z-easy.com.cn')">www.z-easy.com.cn</span>
          </p>
          <p>
            <ab-svg name="address"></ab-svg>
            地址：深圳市南山区前海深港合作区金融街 1 号弘毅大厦 9 楼
          </p>
          <p>
            <ab-svg name="phone"></ab-svg>
            电话： <span style="color: #1884ff;">4006566988</span>
          </p>
        </div>
        <div class="code">
          <img src="@/assets/img/authentication-code.png" alt="">
          <p>扫码咨询客服</p>
        </div>
        <div class="about">
          <i></i>
          <a href="https://www.z-easy.com.cn/" target="_blank">关于一咻</a>
        </div>
      </el-col>
    </el-row>
    <textarea class="copy-text" id="copyText"></textarea>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import vueCookie from 'vue-cookies'
export default {
  name: 'authentication',
  data() {
    return {
      info: {}
    }
  },

  computed: {
  },
  created() {
    if(window.location.href.indexOf('uuid') == -1) {
      return
    }
    let urlStr = unescape(window.location.href).split('?')[1]
    let arr = urlStr.split('&')
    let uuid = arr.filter(e=>e.indexOf('uuid') != '-1')[0].split('=')[1]
    this.getInfo(uuid)
  },
  methods: {    
    open(url) {
      open(url)
    },
    // 复制单号
    copyNmuber(infoText) {
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = infoText // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },
    getInfo(uuid) {
      this.$post('/cms/taoicPublished/queryCustomsInfo', {uuid}).then(({data}) => {
        if(data && data.code === 'C0000') {
          this.info = data.result || {}
        }else{
          this.$message.error(data.message)
        }
      })
    }
  }
};
</script>

<style lang="scss">
.authentication {
  position: relative;
  display: table;
  width: 100%;
  height: 100vh;
  // background-image: url(@/assets/img/login-bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .left{
    position: relative;
    .title{
      position: absolute;
      top: 45px;
      left: 250px;
      font-size: 18px;
    }
    .logo {
      background-image: url(@/assets/img/login-logo.png);
      height: 50px;
      width: 194px;
      position: absolute;
      left: 35px;
      top: 35px;
    }
    .result{
      width: 344px;
      height: 370px;
      padding: 50px;
      position: absolute;
      top: 50%;
      margin-top: -200px;
      left: 50%;
      margin-left: -172px;
      border-radius: 10px;
      box-shadow: 0 0 20px #ccc;
      p{
        line-height: 28px;
      }
      span{
        color: #1884ff;
      }
      .result-title{
        font-size: 20px;
        text-align: center;
      }
    }
  }
  .right{
    position: relative;
    height: 100%;
    background-image: url(@/assets/img/authentication.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .info{
      position: absolute;
      left: 15%;
      top: 70vh;
      p{
        margin-bottom: 10px;
      }
      .icon-svg{
        width: 18px;
        height: 18px;
        float: left;
        margin-right: 15px;
      }
    }
    .code{
      position: absolute;
      top: 69vh;
      left: 73%;
      img{
        width: 100px;
      }
      p{
        text-align: center;
      }
    }
    .about {
      position: absolute;
      top: 35px;
      right: 35px;
      font-size: 16px;
      i {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 4px 8px 0 0;
        vertical-align: top;
        background: url(@/assets/img/about.png) no-repeat;
      }
      a {
        color: #111;
        text-decoration: none;
      }
    }
  }
}
</style>
